import React, { useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { client } from '../client';
import Spinner from './Spinner';
import { categories } from '../utils/utils';

const CreatePin = ({ user }) => {
  const [fields, setFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invalidImageType, setInvalidImageType] = useState(false);
  const [imageAsset, setImageAsset] = useState('');
  const [title, setTitle] = useState('');
  const [about, setAbout] = useState('');
  const [destination, setDestination] = useState('');
  const [category, setCategory] = useState('');

  const handleFileUpload = (e) => {
    const { name, type } = e.target.files[0];
    if (
      type === 'image/jpeg' ||
      type === 'image/png' ||
      type === 'image/gif' ||
      type === 'image/svg' ||
      type === 'image/tiff'
    ) {
      setInvalidImageType(false);
      setLoading(true);
      client.assets
        .upload('image', e.target.files[0], {
          contentType: type,
          filename: name,
        })
        .then((document) => {
          setImageAsset(document);
          setLoading(false);
        })
        .catch((error) => console.log(error));
    } else {
      setInvalidImageType(true);
    }
  };

  const handleSavePinButtonClicked = () => {
    if (
      title &&
      about &&
      destination &&
      imageAsset?._id &&
      category !== 'other'
    ) {
      const doc = {
        _type: 'pin',
        title,
        about,
        destination,
        image: {
          _type: 'image',
          asset: {
            _type: 'reference',
            _ref: imageAsset?._id,
          },
        },
        userId: user._id,
        postedBy: {
          _type: 'postedBy',
          _ref: user._id,
        },
        category,
      };
      client.create(doc).then(() => navigate('/'));
    } else {
      setFields(true);
      setTimeout(() => setFields(false), 2000);
    }
  };

  const navigate = useNavigate();
  return (
    <div className='flex flex-col mt-5 justify-center items-center lg:h-4/5'>
      {fields && (
        <p className='text-red-500 text-xl transition-all duration-150 ease-in'>
          Please fill all the fields
        </p>
      )}
      <div className='flex lg:flex-col lg:p-5 lg:w-4/5 flex-row justify-center items-center bg-white p-3 w-full'>
        <div className='bg-secondaryColor p-3 flex flex-0.7 w-full'>
          <div className='flex justify-center items-center flex-col border-2 border-dotted border-gray-300 p-3 w-full h-420'>
            {loading && <Spinner />}
            {invalidImageType && <p> Invalid Image Type </p>}
            {!imageAsset ? (
              <label>
                <div className='flex flex-col items-center justify-center h-full'>
                  <div className='flex flex-col justify-center items-center'>
                    <p className='font-bold text-2xl'>
                      <AiOutlineCloudUpload />
                    </p>
                    <p className='text-lg'>Click to upload</p>
                  </div>
                  <p className='mt-32 text-gray-400'>
                    Recommendation: use high quality JPG, SVG, PNG, GIF or TIFF
                    less than 20 MB.
                  </p>
                </div>
                <input
                  type='file'
                  onChange={handleFileUpload}
                  name='upload-image'
                  className='w-0 h-0'
                />
              </label>
            ) : (
              <div className='relative h-full'>
                <img
                  src={imageAsset?.url}
                  alt='uploaded-pic'
                  className='w-full h-full'
                />
                <div className='flex'>
                  <label className='absolute left-3 bg-red-500 opacity-70 bottom-3 text-xl cursor-pointer hover:shadow-md hover:opacity-100 outline-none flex rounded-full p-2 justify-center flex-col items-center'>
                    <p className='font-bold text-2xl'>
                      <AiOutlineCloudUpload />
                    </p>
                    <input
                      type='file'
                      onChange={handleFileUpload}
                      name='upload again'
                      className='w-0 cursor-pointer h-0'
                    />
                  </label>
                  <button
                    type='button'
                    className='absolute bottom-3 hover:opacity-100 opacity-70 right-3 p-3 rounded-full bg-white text-xl cursor-pointer outline-none hover:shadow-md transition-all duration-500 ease-in-out'
                    onClick={() => setImageAsset(null)}
                  >
                    <MdDelete />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='flex flex-col gap-6 lg:pl-5 mt-5 w-full'>
          <input
            type='text'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder='Add your title here'
            className='outline-none text-2xl sm:text-3xl font-bold border-b-2 border-gray-200 p-2'
          />
          {user && (
            <div className='flex gap-2 my-2 items-center bg-white rounded-lg'>
              <img
                src={user.image}
                alt='user-img'
                className='w-10 h-10 rounded-full'
              />
              <p className='font-bold'> {user.userName} </p>
            </div>
          )}
          <input
            type='text'
            value={about}
            onChange={(e) => setAbout(e.target.value)}
            placeholder='What is your pin about?'
            className='outline-none text-base sm:text-lg border-b-2 border-gray-200 p-2'
          />
          <input
            type='text'
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
            placeholder='Add a destination link'
            className='outline-none text-base sm:text-lg border-b-2 border-gray-200 p-2'
          />
          <div className='flex flex-col'>
            <div>
              <p className='mb-2 font-semibold text-lg sm:text-xl'>
                Choose Pin Category:
              </p>
              <select
                className='outline-none w-4/5 text-base border-b-2 border-gray-200 p-2 rounded-md cursor-pointer'
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value='other' className='bg-white'>
                  Select a category
                </option>
                {categories.map((category) => {
                  return (
                    <option
                      key={category.name}
                      value={category.name}
                      className='text-base border-0 outline-none capitalize text-black bg-white'
                    >
                      {category.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className='flex justify-end ites-end mt-5'>
              <button
                type='button'
                className='bg-red-500 text-white font-bold p-2 rounded-full w-28 outline-none'
                onClick={handleSavePinButtonClicked}
              >
                Save Pin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePin;
